import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React from 'react';

// Based on:
// - https://stackoverflow.com/questions/73933932/using-an-icon-uploaded-to-a-kit-with-fontawesome-react/75980519
// - https://jeroenpelgrims.com/custom-fontawesome-kit-icons-in-react/

type KitNames =
  | 'fa-regular-money-bill-circle-info'
  | 'fa-solid-house-blank-circle-xmark'
  | 'fa-solid-house-blank-shield'
  | 'fa-solid-house-circle-info'
  | 'fa-solid-money-from-bracket-circle-arrow-down'
  | 'fa-solid-money-from-bracket-circle-arrow-up'
  | 'fa-solid-sparkles-pen'
  | 'fa-solid-user-circle-info'
  | 'fa-zuid-info';

type KitDefinition = {
  prefix: 'fa-kit';
  iconName: KitNames;
};

type CustomIconDefinition = IconDefinition | KitDefinition;

interface ICustomIconProps {
  icon: CustomIconDefinition;
  className?: string;
  title?: string;
  onClick?: () => void;
  'data-test-id'?: string;
}

export const CustomIcon: React.FC<ICustomIconProps | FontAwesomeIconProps> = ({ icon, ...rest }) => {
  const { className, title, onClick } = rest;
  const isCustom = typeof icon === 'object' && 'prefix' in icon;
  return (
    <>
      {isCustom && (
        <i
          className={classNames(icon.prefix, icon.iconName, className)}
          title={title}
          onClick={onClick as any}
          data-test-id={rest['data-test-id']}
        />
      )}
      {!isCustom && <FontAwesomeIcon icon={icon} {...rest} />}
    </>
  );
};

export const faRegularMoneyBillCircleInfo: KitDefinition = {
  prefix: 'fa-kit',
  iconName: 'fa-regular-money-bill-circle-info',
};

export const faSolidHouseBlankCircleXMark: KitDefinition = {
  prefix: 'fa-kit',
  iconName: 'fa-solid-house-blank-circle-xmark',
};

export const faSolidHouseBankShield: KitDefinition = {
  prefix: 'fa-kit',
  iconName: 'fa-solid-house-blank-shield',
};

export const faSolidHouseCircleInfo: KitDefinition = {
  prefix: 'fa-kit',
  iconName: 'fa-solid-house-circle-info',
};

export const faSolidMoneyFromBracketCircleArrowUp: KitDefinition = {
  prefix: 'fa-kit',
  iconName: 'fa-solid-money-from-bracket-circle-arrow-up',
};
export const faSolidMoneyFromBracketCircleArrowDown: KitDefinition = {
  prefix: 'fa-kit',
  iconName: 'fa-solid-money-from-bracket-circle-arrow-down',
};

export const faSolidSparklesPen: KitDefinition = {
  prefix: 'fa-kit',
  iconName: 'fa-solid-sparkles-pen',
};

export const faSolidUserCircleInfo: KitDefinition = {
  prefix: 'fa-kit',
  iconName: 'fa-solid-user-circle-info',
};

export const faZuidInfo: KitDefinition = {
  prefix: 'fa-kit',
  iconName: 'fa-zuid-info',
};
